(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MembershipFee', MembershipFee);

    MembershipFee.$inject = ['$resource', 'DateUtils'];

    function MembershipFee ($resource, DateUtils) {
        var resourceUrl =  'api/membership-fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.year = DateUtils.convertLocalDateFromServer(data.year);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.year = DateUtils.convertLocalDateToServer(copy.year);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.year = DateUtils.convertLocalDateToServer(copy.year);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
